export const styles = {
  container: {
    width: '100%',
    height: '100vh',
    display: 'grid',
    placeItems: 'center',
  },
  boxNotFound: {
    width: 'auto',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  image: {
    width: '300px',
    height: 'auto',
  },
  content: {
    marginLeft: '50px',
    width: 'auto',
    height: '70%',
  },
};
